import { fetchData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

interface BrandResponseItem {
  brand: string;
  volume_mix: number;
}

export const fetchBrandData = async (payload: any): Promise<{ [key: string]: number }> => {
  const response = await fetchData<BrandResponseItem[]>(
    API_ENDPOINTS.SCENARIO_INPUT.FETCH_BRAND_AND_VOLUME_MIX_DATA,
    payload,
  );

  const brands: { [key: string]: number } = {};
  response.forEach((item) => {
    brands[item.brand] = item.volume_mix;
  });

  return brands;
};
